"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CameraSelection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const CameraSelection = ({ cameras, onChange }) => {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("label", { children: "Kamera" }), (0, jsx_runtime_1.jsx)("select", { id: "camera", onChange: (event) => onChange(cameras.find(c => c.id === event.target.value)), children: cameras.map(camera => (0, jsx_runtime_1.jsx)("option", { value: camera.id, children: camera.parent ? camera.parent.name : camera.name })) })] }));
};
exports.CameraSelection = CameraSelection;
